import { castResponse } from "@utils/hooks/useTypedRequest";
import { PostRequest } from "./http/BaseRequest";
import W2UiFilterBuilder from "./w2ui";
import { SearchItem } from "./w2ui/w2const";
import { RecordsResponse } from "./http/responses/BaseResponse";

export interface IMinerErrors {
  Timestamp: number;
  TimestampStr: string;
  Data: string;
  Id: number;
  Code: string;
  MinerId: number;
}
export const getMinerErrors = {
  makeRequest(id: number) {
    const builder = new W2UiFilterBuilder();
    builder.setSearch([SearchItem.intIs("id", id)]);
    return new PostRequest(
      "/admin/control/errors/get",
      builder.build().stringParams
    );
  },
  makeResponse: castResponse<RecordsResponse<IMinerErrors>>,
};


export const resetMinerErrors = {
  makeRequest(ids: number[], minerId: number, all = false) {
    return new PostRequest("/admin/control/errors/delete", {
      id: ids.join(","),
      minerId,
      all,
    });
  },
};

export const deleteMinerErrors = {
  makeRequest(minerId: number) {
    return new PostRequest("/admin/control/errors/delete", {
      miner_id: minerId
    });
  }
}

export const resetAllMinerErrors = {
  makeRequest() {
    return new PostRequest("/admin/control/errors/delete", {
      all: true,
    });
  },
};


export const getMinerHistoryErrors = {
  makeRequest(id: number) {
    const params = new W2UiFilterBuilder()

      .setSearch([SearchItem.intIs("id", id)])
      .build()
      .stringParams;
    return new PostRequest(
      "/admin/control/errors/history/list",
      params
    );
  },
  makeResponse: castResponse<RecordsResponse<IMinerErrors>>,
};